export default {
	state: {
		config: {
			uploadSize: 50,
			multiLanguage: false,
			defaultLanguage: "zh",
			openMessageNotice: true
		}
	},
	mutations: {
		setConfig(state, config) {
			state.config = config;
		},
		clear(state) {
			state.config = {
				uploadSize: 50,
				multiLanguage: false,
				defaultLanguage: "zh",
				openMessageNotice: true
			};
		}
	},
	actions: {
		loadConfig(context) {
			return new Promise((resolve, reject) => {
				// 这里返回默认配置
				const defaultConfig = {
					uploadSize: 50,
					multiLanguage: false,
					defaultLanguage: "zh",
					openMessageNotice: true
				};
				context.commit("setConfig", defaultConfig);
				resolve(defaultConfig);
			});
		}
	}
};
